import React from 'react';
import { useBooking } from '../../hooks/useBookingContext';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Plus, X } from 'lucide-react';

const LocationSelector: React.FC = () => {
  const { currentBookingLink, updateLocations } = useBooking();
  const [newLocation, setNewLocation] = React.useState('');

  if (!currentBookingLink) return null;

  const handleAddLocation = () => {
    if (newLocation.trim()) {
      const updatedLocations = [...(currentBookingLink.locations || []), newLocation.trim()];
      updateLocations(updatedLocations);
      setNewLocation('');
    }
  };

  const handleRemoveLocation = (index: number) => {
    const updatedLocations = currentBookingLink.locations?.filter((_, i) => i !== index) || [];
    updateLocations(updatedLocations);
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddLocation();
    }
  };

  return (
    <div className="space-y-4 animate-fade-in">
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">Meeting Locations</h3>
        <p className="text-sm text-muted-foreground">
          Add locations where you can meet in person
        </p>
      </div>

      <div className="flex gap-2">
        <Input
          value={newLocation}
          onChange={(e) => setNewLocation(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter a location"
          className="flex-1"
        />
        <Button
          onClick={handleAddLocation}
          disabled={!newLocation.trim()}
          type="button"
        >
          <Plus className="h-4 w-4" />
        </Button>
      </div>

      <div className="space-y-2">
        {currentBookingLink.locations?.map((location, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-2 bg-secondary rounded-md"
          >
            <span className="text-sm">{location}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleRemoveLocation(index)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        ))}
      </div>

      {currentBookingLink.meetingTypes.inPerson && 
       (!currentBookingLink.locations || currentBookingLink.locations.length === 0) && (
        <p className="text-sm text-destructive">
          Please add at least one location for in-person meetings
        </p>
      )}
    </div>
  );
};

export default LocationSelector;